import React, { Component } from 'react'
import Cropper from 'cropperjs'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import Icon from '../../Icons'
import { setFormFieldFile } from '../../../reducers/formReducer'

export class ImageField extends Component {
  constructor(props) {
    super(props)
    this.cropTargetRef = React.createRef()
    this.state = {
      modalIsActive: false,
      isFileValid: false,
      cropper: null,
    }
    this.handleEscape = this.handleEscape.bind(this)
    this.hasExtension = this.hasExtension.bind(this)
    this.handleFileChoosing = this.handleFileChoosing.bind(this)
    this.createCropper = this.createCropper.bind(this)
    this.handleCroppingImage = this.handleCroppingImage.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.renderCroppingModal = this.renderCroppingModal.bind(this)
  }

  componentDidMount() {
    const { formType, fieldName, image } = this.props
    const initialValue = image || ''
    this.props.setFormFieldImage(formType, fieldName, initialValue, false)
    document.addEventListener('keydown', this.handleEscape)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape(e) {
    e = e || window.event
    if (e.keyCode === 27 && this.state.modalIsActive) {
      this.closeModal()
    }
  }

  componentWillReceiveProps(nextProps) {
    const { formType, fieldName } = this.props
    if (nextProps.image !== this.props.image) {
      this.props.setFormFieldImage(formType, fieldName, nextProps.image, false)
    }
  }

  hasExtension(inputName, exts) {
    const fileName = document.querySelector(`input[name="${inputName}"]`).value
    return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(fileName)
  }

  handleInputFile(e) {
    e.target.value = null
  }

  handleFileChoosing(e) {
    const file = e.target.files[0]
    const reader = new FileReader()
    let image = ''
    reader.onload = (e) => {
      image = e.target.result
      if (
        file.size > 2000000 ||
        !this.hasExtension(this.props.fieldName, ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'])
      ) {
        this.openModal(false)
      } else {
        this.openModal(true)
        this.createCropper(image)
      }
    }
    reader.readAsDataURL(file)
    this.props.callbackAfterChange?.()
  }

  createCropper(image) {
    const cropTarget = this.cropTargetRef.current
    cropTarget.src = image
    const cropper = new Cropper(cropTarget, {
      multiple: false,
      dragCrop: false,
      dashed: false,
      movable: false,
      dragMode: 'crop',
      autoCropArea: 0.65,
      restore: false,
      guides: false,
      center: false,
      highlight: false,
      scalable: true,
      resizable: false,
      cropBoxMovable: true,
      toggleDragModeOnDblclick: false,
      viewMode: 2,
      wheelZoomRatio: 0,
      aspectRatio: this.props.imageRatio,
    })
    this.setState({ cropper: cropper })
  }

  handleCroppingImage(e) {
    e.preventDefault()
    const image = this.state.cropper.getCroppedCanvas().toDataURL()
    this.state.cropper.getCroppedCanvas().toBlob((blob) => {
      const { setFormFieldImage, formType, fieldName } = this.props
      setFormFieldImage(formType, fieldName, image, blob)
    }, 'image/jpeg')
    this.closeModal()
  }

  openModal(isFileValid = false) {
    this.setState({ modalIsActive: true, isFileValid })
  }

  closeModal() {
    if (this.state.isFileValid && this.state.cropper) {
      this.state.cropper.destroy()
    }
    this.setState({ modalIsActive: false, isFileValid: false })
    if (this.cropTargetRef.current) {
      this.cropTargetRef.current.src = ''
    }
  }

  renderCroppingModal() {
    const classes = `modal modal--avatar-crop ${this.state.modalIsActive ? 'is-active' : ''}`
    return (
      <div className={classes}>
        <div
          className="modal-background"
          onClick={(e) => {
            e.preventDefault()
            this.closeModal()
          }}
        />
        <div className="modal-content">
          <div className="modal-cropper-wrapper">
            <img
              ref={this.cropTargetRef}
              src="#"
              style={{ display: this.state.isFileValid ? undefined : 'none' }}
            />
            {!this.state.isFileValid && (
              <div className="modal__warning">
                <strong>The uploaded file has an invalid type or exceeds the size limit.</strong>
                <small>Allowed File Types - JPG, JPEG, PNG</small>
                <small>File Size Limit - 2 MB</small>
              </div>
            )}
          </div>
          {this.state.isFileValid && (
            <button
              id="saveCropBtn"
              onClick={this.handleCroppingImage}
              className="button button-primary"
            >
              <span>Save</span>
            </button>
          )}
          {!this.state.isFileValid && (
            <button
              id="closeCropBtn"
              onClick={(e) => {
                e.preventDefault()
                this.closeModal()
              }}
              className="button button-primary"
            >
              <span>Close</span>
            </button>
          )}
        </div>
        <button
          onClick={(e) => {
            e.preventDefault()
            this.closeModal()
          }}
          className="modal-close is-large"
        />
      </div>
    )
  }

  render() {
    const { form, formType, fieldName, additionalClass, isDisabled, image, showImageBeforeChange } =
      this.props
    return (
      <div className={`field field-v1-image ${additionalClass || ''}`}>
        <div className="field-image-v1__media-wrapper">
          <div className="field-image-v1__media">
            <img src={showImageBeforeChange ? image : form[formType][fieldName].image} />
          </div>
          {!isDisabled && (
            <div className="field-image-v1__options">
              <div className="field-image-v1__add">
                <label htmlFor="file-input">
                  <Icon icon="editPen" viewBox="0 0 28 27" />
                </label>
                <input
                  id="file-input"
                  type="file"
                  name={fieldName}
                  onChange={this.handleFileChoosing}
                  onClick={this.handleInputFile}
                />
              </div>
            </div>
          )}
        </div>
        {this.renderCroppingModal()}
      </div>
    )
  }
}

ImageField.propTypes = {
  form: PropTypes.object,
  fieldName: PropTypes.string.isRequired,
  formType: PropTypes.string,
  image: PropTypes.string,
  defaultImage: PropTypes.string,
  label: PropTypes.string,
  imageRatio: PropTypes.number.isRequired,
  additionalClass: PropTypes.string,
  setFormFieldImage: PropTypes.func,
  isDisabled: PropTypes.bool,
  showImageBeforeChange: PropTypes.bool,
  callbackAfterChange: PropTypes.func,
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldImage: setFormFieldFile },
)(ImageField)
